/** Record IDs must be present before an API action can address persisted data. */
export function requireRecordId(id: string | null | undefined): string {
  if (typeof id !== 'string' || id.trim() === '') throw new Error('记录缺少有效 ID，请刷新列表后重试');
  return id;
}
export function hasRecordId<T extends { id?: string }>(record: T): record is T & { id: string } {
  return typeof record.id === 'string' && record.id.trim() !== '';
}
export function isPresent<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
